var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"e4s-card e4s-card--generic"},[_vm._t("all",function(){return [_c('div',[_vm._t("header"),_vm._v(" "),_vm._t("content"),_vm._v(" "),_vm._t("footer")],2)]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }